import React, { useState } from 'react';
import { useHistory, Route, Switch, useLocation } from 'react-router-dom';
import { Menu, Select, Dropdown } from 'antd';

import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import $ from 'jquery';
import Page404 from '../404/404';

import Default from '../default/default';

import PartnerHome from '../partnerHome/partnerHome';
import PartnerCreateJobPosting from '../partnerCreateJobPosting/partnerCreateJobPosting';
import StudentApplications from '../studentApplications/studentApplications';
import PartnerJobPostingDetail from '../partnerJobPostingDetail/partnerJobPostingDetail';
import PartnerSeeAllJobPosting from '../partnerSeeAllJobPosting/partnerSeeAllJobPosting';
import userSelectedImg from '../../public/img/newMain/UserSelected.png'

import PartnerReviewStudentApplication from '../partnerReviewStudentApplication/partnerReviewStudentApplication';
import PartnerDetail from '../partnerDetail/partnerDetail';
import PartnerSeeAllApplications from '../partnerSeeAllApplications/partnerSeeAllApplications';
import PartnerStudentReport from '../partnerReport/academicStudentReport';
import PartnerIndustrialPartnerReport from '../partnerReport/academicIndustrialPartnerReport';
import PartnerStaffReport from '../partnerReport/academicStaffReport';
import PartnerResources from '../partnerResources/partnerResources';
import PartnerResourcesContext from '../partnerResources/partnerResourcesContext';
import CompleteWPAForm from '../completeWPAForm/completeWPAForm';
// css
import './newMain.css'

// img
import userImg from '../../public/img/newMain/User.png'
import homeIconImg from '../../public/img/newMain/HomeIcon.png'
import selectHomeIconImg from '../../public/img/newMain/SelectHomeIcon.png'
import jobIconImg from '../../public/img/newMain/JobIcon.png'
import selectJobIconImg from '../../public/img/newMain/SelectJobIcon.png'
import CompanyLogo from '../../public/img/company/companyLogo.png';
import resources from '../../public/img/newMain/resources.png'
import resourcesnoselected from '../../public/img/newMain/resourcesnoselected.png'
import baogaoImg from '../../public/img/newMain/baogao.png'
import baogaoSelectImg from '../../public/img/newMain/baogaoSelect.png'
import logoImg from '../../public/img/logo.jpg';
import PartnerJobManagementReport from '../partnerReport/partnerJobManagementReport';
import PartnerJobApplicationReport from '../partnerReport/partnerJobApplicationReport';
import PartnerChangePassword from '../partnerChangePassword/partnerChangePassword';

export let partnerCheckLogin;

const PartnerMain = (props) => {

    const history = useHistory();
    const location = useLocation();
    const [path, setPath] = useState('');
    const [userOptions, setUserOptions] = useState([]);

    partnerCheckLogin = () => {
        if (Config.userInfo.userId) {
            searchPartner();
            searchCohortYear()
        } else {
            if (Base.isEmpty(Config.header.authorization)) {
                Config.header.authorization = localStorage.getItem(Config.tokenPrefix + 'AccessToken');
            }
            let token = localStorage.getItem(Config.tokenPrefix + 'RefreshToken');
            if (token) {
                $.ajax({
                    url: Config.apiServer + "partner/login/checkToken",
                    type: "POST",
                    data: JSON.stringify(token),
                    async: false,
                    headers: Config.header,
                    contentType: "application/json; charset=utf-8",
                    dataType: 'json',
                    success: (data) => {
                        if ("SUCCESS" === data.msg && data.object.userInfo.userType === 'PARTNER') {
                            Config.userInfo = data.object.userInfo;
                            Config.header.authorization = data.object.accessToken + '';
                            Config.sasToken = data.object.sasToken;
                            localStorage.setItem(Config.tokenPrefix + 'AccessToken', data.object.accessToken);
                            localStorage.setItem(Config.tokenPrefix + 'RefreshToken', data.object.refreshToken);
                            searchPartner();
                            searchCohortYear()
                        } else {
                            Base.removeAllLocalStorage();
                            if (window.location.href.lastIndexOf("/login") === -1) {
                                history.push("/login");
                            }
                        }
                    },
                    error: (jqXHR, textStatus, errorThrown) => {
                    }
                });
            } else {
                history.push("/login");
            }
        }
    }

    const searchCohortYear = () => {
        $.ajax({
            url: Config.apiServer + "partner/back/cohort/searchCohortYear",
            type: "POST",
            async: false,
            headers: Config.header,
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            success: (data) => {
                if ("SUCCESS" === data.msg) {
                    Config.cohort = data?.object
                } else {
                    console.log("error", data.msg);
                }
            },
            error: (jqXHR, textStatus, errorThrown) => {
            }
        })
    }

    const searchPartner = () => {
        $.ajax({
            url: Config.apiBackServer + "user/searchPartner",
            type: "POST",
            headers: Config.header,
            async: false,
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            success: (data) => {
                if ("SUCCESS" === data.msg) {
                    Config.partnerInfo = data.object;
                    setUserOptions([
                        {
                            value: Config.userInfo?.userName,
                            label: Config.userInfo?.userName,
                        },
                    ])
                } else {
                    console.log("error", data.msg);
                }
            },
            error: (jqXHR, textStatus, errorThrown) => {
            }
        });
    }

    const jump = (path) => {
        if (!Config.userInfo.operationFlag) {
            localStorage.removeItem('partnerDuplicateJobId');
            history.push(path);
            setPath(path)
        }
    }

    const back = () => {
        history.goBack();
    }

    const logout = () => {
        fetch(Config.apiServer + "partner/login/lgout", {
            method: 'POST',
            body: JSON.stringify(Config.userInfo),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.json()).then((data) => {
            if ("SUCCESS" === data.msg) {
                Config.userInfo = {};
                Config.partnerInfo = {};
                Config.header.authorization = '';
                Base.removeAllLocalStorage();
                history.push('/login');
            } else {
                console.log(data.msg);
            }
        }).catch(err => { }).finally(() => { });
    }

    const menu2 = (
        <Menu className='reportNewMainBtn'>
            {/* <Menu.Item key="1"   onClick={() => { jump('/partner/studentReport') }}>Student Report</Menu.Item> */}
            {/* <Menu.Item key="2"   onClick={() => { jump('/partner/academicReport') }}>Academic Report</Menu.Item> */}
            {/* <Menu.Item key="3"   onClick={() => { jump('/partner/ipReport') }}>Industry Partner Report</Menu.Item> */}
            <Menu.Item key="4" onClick={() => { jump('/partner/partnerJobPostingReport') }}>Job Posting Report</Menu.Item>
            <Menu.Item key="5" onClick={() => { jump('/partner/partnerJobApplicationReport') }}>Job Application Report</Menu.Item>
        </Menu>
    );

    return (
        <div id="newMain">
            {/* 左边菜单区域 */}
            <div id="leftMenu">
                <div className='logoBox'>
                    <img src={logoImg} />
                </div>
                <div className='menuLine'>
                </div>
                <div className='menuFlex'>
                    {/* 添加menu */}
                    <div>
                        {
                            location.pathname === '/partner/partnerHome' || location.pathname === '/partner'
                                || location.pathname.includes('partnerSeeAllApplications') || location.pathname.includes('partnerSeeAllJobPosting')
                                || location.pathname.includes('partnerJobPostingDetail') || location.pathname.includes('partnerReviewStudentApplication') ?
                                <div className='menuItemSelect' >
                                    <img src={selectHomeIconImg} />
                                </div>
                                :
                                <div className='menuItem'>
                                    <img src={homeIconImg} onClick={() => jump('/partner/partnerHome')} />
                                </div>
                        }
                        {
                            location.pathname.includes('partnerCreateJobPosting') ?
                                <div className='menuItemSelect'>
                                    <img src={selectJobIconImg} />
                                </div>
                                :
                                <div className='menuItem'>
                                    <img src={jobIconImg} onClick={() => jump('/partner/partnerCreateJobPosting')} />
                                </div>
                        }
                        <Dropdown destroyPopupOnHide={true} overlay={menu2} placement="bottomLeft" trigger={['click']}>
                            {
                                location.pathname.includes('studentReport') || location.pathname.includes('academicReport') || location.pathname.includes('ipReport')
                                    || location.pathname.includes('partnerJobPostingReport') || location.pathname.includes('partnerJobApplicationReport') ?
                                    <div className='menuItemSelect' title='Report'>
                                        <img src={baogaoSelectImg} />
                                    </div>
                                    :
                                    <div className='menuItem' title='Report'>
                                        <img src={baogaoImg} />
                                    </div>
                            }
                        </Dropdown>
                        {
                            (location.pathname === '/partner/resources' || location.pathname.includes('/partner/resourcesContext')) ?
                                <div className='menuItemSelect' title='Resources'>
                                    <img src={resources} />
                                </div>
                                :
                                <div className='menuItem' title='Resources'>
                                    <img src={resourcesnoselected} onClick={() => jump('/partner/resources')} />
                                </div>
                        }
                    </div>
                    {/* 底部固定menu */}
                    <div>
                        {
                            (location.pathname.includes('/partner/partnerDetail') || location.pathname.includes('/partner/partnerChangePassword')) ?
                                <div className='menuItemSelect'>
                                    <img src={userSelectedImg} />
                                </div>
                                :
                                <div className='menuItem'>
                                    <img src={userImg} onClick={() => jump('/partner/partnerDetail')} />
                                </div>
                        }
                    </div>
                </div>
            </div>
            {/* 右边内容区域 */}
            <div id="rightMain">
                <div className="head">
                    {location.pathname != '/partner/partnerHome' && location.pathname != '/partner' && location.pathname != '/partner/ipReport'
                        && location.pathname != '/partner/studentReport' && location.pathname != '/partner/academicReport'
                        && location.pathname != '/partner/resources' && !location.pathname.includes('partnerJobPostingReport') && !location.pathname.includes('partnerJobApplicationReport')
                        ?
                        <div className='backBox' onClick={() => back()}>
                            &lt;&nbsp;&nbsp;Back
                        </div>
                        :
                        <div className='backBox' onClick={() => jump('/partner/resources')}>Resources/FAQ</div>
                    }
                    <div className='selectBox'>
                        <div className='backBox' onClick={() => logout()}>
                            Logout
                        </div>
                        {/* <Select
                            className='selectLang'
                            defaultValue="English"
                            options={[
                                {
                                    value: 'English',
                                    label: 'English',
                                },
                            ]}
                        /> */}
                        <div className='companySelectBox'>
                            <div className='companySelectImg'>
                                <img src={Config.partnerInfo?.companyLogo ? Config.partnerImg + Config.partnerInfo?.companyLogo + '?' + Config.sasToken : CompanyLogo} />
                            </div>
                            <Select
                                defaultValue={Config.userInfo?.userName}
                                value={Config.userInfo?.userName}
                                options={userOptions}
                            />
                        </div>
                    </div>
                </div>
                <Switch>
                    <Route path="/partner" exact component={PartnerHome} />
                    <Route path="/partner/default" exact component={Default} />
                    {/* MC */}
                    <Route path="/partner/partnerHome" exact component={PartnerHome} />
                    <Route path="/partner/partnerCreateJobPosting" exact component={PartnerCreateJobPosting} />
                    <Route path="/partner/studentApplications/:jobId" exact component={StudentApplications} />
                    <Route path="/partner/partnerJobPostingDetail/:jobId/:flag" exact component={PartnerJobPostingDetail} />
                    <Route path="/partner/partnerSeeAllJobPosting/:showStatus" exact component={PartnerSeeAllJobPosting} />

                    <Route path="/partner/partnerReviewStudentApplication/:jobApplId" exact component={PartnerReviewStudentApplication} />
                    <Route path="/partner/partnerDetail" exact component={PartnerDetail} />
                    <Route path="/partner/partnerSeeAllApplications/:showStatus" exact component={PartnerSeeAllApplications} />

                    <Route path="/partner/studentReport" exact component={PartnerStudentReport} />
                    <Route path="/partner/ipReport" exact component={PartnerIndustrialPartnerReport} />
                    <Route path="/partner/academicReport" exact component={PartnerStaffReport} />
                    <Route path="/partner/partnerJobPostingReport" exact component={PartnerJobManagementReport} />
                    <Route path="/partner/partnerJobApplicationReport" exact component={PartnerJobApplicationReport} />

                    <Route path="/partner/resources" exact component={PartnerResources} />
                    <Route path="/partner/resourcesContext" exact component={PartnerResourcesContext} />
                    <Route path="/partner/partnerChangePassword" exact component={PartnerChangePassword} />

                    <Route exact component={Page404} />
                </Switch>
            </div>
        </div>
    )
}

export default PartnerMain;